import { useEffect, useState } from "react";
import { adminDailyAttendanceApi, FILE_BASE_URL } from "../../app/api";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
 
 
 
 
export default function AllAttendance() {
  const IMAGE_BASE_URL = FILE_BASE_URL;
 
 
  const [selectedDate, setSelectedDate] = useState(new Date());
 
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5; // show 10 records per page
 
 
 
  const [sortBy, setSortBy] = useState("")
  const today = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD
  const navigate = useNavigate();
 
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imagePreview, setImagePreview] = useState(null);
 
  // ✅ Selected Date (default = today)
  const formatDate = (date) =>
    typeof date === "string" ? date.split("T")[0] : "--";
 
  // ✅ Fetch attendance by date
  const fetchAttendance = (date) => {
    setLoading(true);
 
    adminDailyAttendanceApi(date)
      .then((res) => {
        if (res?.success && Array.isArray(res.data)) {
          setRecords(res.data);
        } else {
          setRecords([]);
        }
      })
      .catch(() => setRecords([]))
      .finally(() => setLoading(false));
  };
 
 
  // ✅ Load when date changes
  // useEffect(() => {
  //   fetchAttendance(selectedDate);
  // }, [selectedDate]);
 
  useEffect(() => {
    if (selectedDate) {
      const yyyy = selectedDate.getFullYear();
      const mm = String(selectedDate.getMonth() + 1).padStart(2, '0');
      const dd = String(selectedDate.getDate()).padStart(2, '0');
      const formatted = `${yyyy}-${mm}-${dd}`;
      fetchAttendance(formatted);
    }
  }, [selectedDate]);
 
 
 
 
 
  if (loading) {
    return (
      <div className="p-6 text-center text-gray-600">
        Loading attendance...
      </div>
    );
  }
 
 
 
 
 
 
 
 
 
 
// total_minutes ke liye
const getTotalMinutes = (row) => row.total_minutes || 0;
 
// break_minutes ke liye
const getBreakMinutes = (row) => row.break_minutes || 0;
 
// punch_in (HH:MM:SS) ke liye
const getPunchInSeconds = (time) => {
  if (!time) return 0;
  const [h = 0, m = 0, s = 0] = time.split(":").map(Number);
  return h * 3600 + m * 60 + s;
};
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
  const sortedRecords = [...records].sort((a, b) => {
    // Default alphabetical
    if (!sortBy) {
      return (a.name || "")
        .toLowerCase()
        .localeCompare((b.name || "").toLowerCase());
    }
 
    let result = 0;
 
    if (sortBy === "HOURS") {
      result = getTotalMinutes(b) - getTotalMinutes(a);
    }
 
    if (sortBy === "BREAK") {
      result = getBreakMinutes(b) - getBreakMinutes(a);
    }
 
    if (sortBy === "LATE") {
      result = getPunchInSeconds(a.punch_in) - getPunchInSeconds(b.punch_in);
    }
 
    // If equal, fallback to alphabetical
    if (result === 0) {
      return (a.name || "")
        .toLowerCase()
        .localeCompare((b.name || "").toLowerCase());
    }
 
    return result;
  });
 
 
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);
 
  const totalPages = Math.ceil(sortedRecords.length / recordsPerPage);
 
 
 
 
  // useEffect(() => {
  //   setCurrentPage(1);
  // }, [selectedDate, sortBy]);
 
 
  return (
    <>
      {/* <div className="px-3 md:px-6 mt-4 ">
        <Header />
      </div> */}
 
<div className=" w-full md:mt-14 flex justify-center">
        <div className="w-full max-w-7xl rounded-3xl bg-[#12082F] border border-white/10 shadow-2xl p-6">
 
          {/* HEADER */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
 
            <h2 className="font-semibold text-md whitespace-nowrap text-white">
              All Users Attendance ({(() => {
                const y = selectedDate.getFullYear();
                const m = String(selectedDate.getMonth() + 1).padStart(2, '0');
                const d = String(selectedDate.getDate()).padStart(2, '0');
                return `${y}-${m}-${d}`;
              })()})
 
            </h2>
 
           
 
{/* RIGHT: DATE FILTER + RESET */}
<div className="flex  gap-2 justify-center  ">
 
<select
  value={sortBy}
  onChange={(e) => setSortBy(e.target.value)}
  className="
  appearance-none
    shadow-lg
    rounded-lg
    w-[144px]
    py-2
    px-3
    text-sm
    bg-[#F3F4F6]
    text-gray-700
    border border-gray-300
    focus:outline-none
    focus:ring-1
    focus:ring-gray-200
    cursor-pointer
"
>
  <option value="">Filter</option>
  <option value="HOURS">Total Working Hours</option>
  <option value="BREAK">Total Break Duration</option>
  <option value="LATE">Punch-In Time</option>
</select>
 
 
 
<DatePicker
  selected={selectedDate}
  onChange={(date) => setSelectedDate(date)}
  dateFormatCalendar=" "    // <-- hide the header
  dateFormat="yyyy-MM-dd"
  className="shadow-lg rounded-lg w-[144px] py-2 text-sm bg-[#F3F4F6] px-3 cursor-pointer"
  calendarClassName="custom-calendar"
  showMonthDropdown
  showYearDropdown
  scrollableYearDropdown
  yearDropdownItemNumber={6}
/>
 
 
 
 
  </div>
  <button
      // onClick={() => setSelectedDate(today)}
      onClick={() => setSelectedDate(new Date())}
      className=" px-3 py-2 rounded-lg text-sm bg-[#F3F4F6] hover:bg-gray-200 shadow-lg"
    >
      Reset
    </button>
 
  </div>
 
          {/* TABLE */}
 
          <div className="overflow-x-auto rounded-2xl bg-white/5 backdrop-blur">
            <table className="min-w-[900px] w-full text-sm text-white">
              <thead>
                <tr className="text-left text-gray-300 border-b border-white/10">
              <th className="  p-3 whitespace-nowrap text-sm">Name</th>
                <th className="p-3 whitespace-nowrap text-sm">Punch In</th>
                <th className="p-3 whitespace-nowrap text-sm">Image In</th>
<th className="p-3 whitespace-nowrap text-sm">Image Out</th>
                <th className="p-3 whitespace-nowrap text-sm">Punch Out</th>
                <th className="p-3 whitespace-nowrap text-sm">Total Hours</th>
                <th className="p-3 whitespace-nowrap text-sm">Break</th>
                <th className="p-3 whitespace-nowrap text-sm">Status</th>
                 <th className="p-3 whitespace-nowrap text-sm text-center">Location</th>
                 <th className="p-3 whitespace-nowrap text-sm">Early / Extra</th>
              </tr>
            </thead>
 
 
 
              <tbody>
                {records.length > 0 ? (
                  // records.map((row, i) => (
                    // sortedRecords.map((row, i) => (
                      currentRecords.map((row, i) => (
                    <tr key={row.user_id || i}
                    className="border-b border-white/5 hover:bg-white/10 transition"
                    >
 
                      {/* NAME */}
               
 
<td className="p-3 text-center text-sm">
  <div
    className="flex items-center gap-3 cursor-pointer"
    onClick={() => navigate(`/users/${row.user_id}`)}
  >
    {/* PROFILE PIC */}
    <div className="w-9 h-9 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center shadow">
                            {row.profile_pic ? (
                              <img
                                src={`${IMAGE_BASE_URL}${row.profile_pic}`}
                                className="w-full h-full object-cover"
                                alt="profile"
                              />
                            ) : (
                              <span className="text-gray-400">👤</span>
                            )}
                          </div>
                          <p className="font-medium hover:text-[#3BC9FC] hover:underline whitespace-nowrap">
                            {row.name || "—"}
                          </p>
                        </div>
                      </td>
 
                      {/* DATE */}
               
                      <td className="p-3 text-sm">{row.punch_in || "—"}</td>
 
                      <td className="p-3 text-sm">
                        {row.punch_in_img ? (
                          <img
                            src={`${IMAGE_BASE_URL}${row.punch_in_img}`}
                            className="w-10 h-10 rounded cursor-pointer"
                            onClick={() =>
                              setImagePreview(`${IMAGE_BASE_URL}${row.punch_in_img}`)
                            }
                          />
                        ) : "—"}
                      </td>
 
                      <td className="p-3 text-sm">
                        {row.punch_out_img ? (
                          <img
                            src={`${IMAGE_BASE_URL}/${row.punch_out_img}`}
                            className="w-10 h-10 rounded cursor-pointer"
                            onClick={() =>
                              setImagePreview(`${IMAGE_BASE_URL}/${row.punch_out_img}`)
                            }
                          />
                        ) : "—"}
                      </td>
 
                      <td className="p-3 text-sm">{row.punch_out || "—"}</td>
 
                      <td className="p-3 text-sm">
                        {row.total_minutes
                          ? `${Math.floor(row.total_minutes / 60)}h ${row.total_minutes % 60}m`
                          : "—"}
                      </td>
 
                      {/* <td className="p-3 text-sm">{row.break_minutes ?? 0}m</td> */}
                      <td className="p-3 text-sm">
  {Number(row.break_minutes) === 0
    ? "Not taken "
    : `${row.break_minutes}m`}
</td>
 
 
                      <td className="p-3 text-sm">
                        <span className={`px-3 py-1 rounded-full text-xs ${
                          row.status ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
                        }`}>
                          {row.status ? "Present" : "Absent"}
                        </span>
                      </td>
 
                      <td className="p-3 text-sm text-center">
                        {row.punch_in_area || row.punch_in_city || row.punch_in_country ? (
                          <div className="text-xs">
                            {row.punch_in_area && <span>{row.punch_in_area}, </span>}
                            {row.punch_in_city && <span>{row.punch_in_city}, </span>}
                            {row.punch_in_country && <span>{row.punch_in_country}</span>}
                          </div>
                        ) : "—"}
                      </td>
 
                      <td className="p-3 text-xs text-sm">
                        Early: {row.early_time || "0m"} <br />
                        Extra: {row.extra_time || "0m"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center p-6 text-gray-500">
                      No Attendance Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
 
 
 
          </div>
          {totalPages > 1 && (
            <div className="flex justify-center mt-6 items-center gap-4">
              <button
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                className="px-4 py-2 rounded-lg text-sm transition bg-white/10 text-white hover:bg-white/20 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
              >
                Prev
              </button>
              <span className="text-sm text-white/90 font-medium">
                Page {currentPage} of {totalPages}
              </span>
              <button
                 onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                 disabled={currentPage === totalPages}
                 className="px-4 py-2 rounded-lg text-sm transition bg-white/10 text-white hover:bg-white/20 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
 
      {/* IMAGE MODAL */}
      {imagePreview && (
        <div
          className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
          onClick={() => setImagePreview(null)}
        >
          <div className="bg-white p-4 rounded-xl">
            <img src={imagePreview} className="max-h-[80vh]" />
          </div>
        </div>
      )}
    </>
  );
}
 






// import { useEffect, useState } from "react";
// import { adminDailyAttendanceApi } from "../../app/api";
// import { useNavigate } from "react-router-dom";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";




// export default function MyAttendance() {


//   const [selectedDate, setSelectedDate] = useState(new Date());

//   const [currentPage, setCurrentPage] = useState(1);
//   const recordsPerPage = 5; // show 10 records per page



//   const [sortBy, setSortBy] = useState("")
//   const today = new Date().toISOString().split("T")[0];
//   const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
//   const navigate = useNavigate();

//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [imagePreview, setImagePreview] = useState(null);

//   // ✅ Selected Date (default = today)
//   const formatDate = (date) =>
//     typeof date === "string" ? date.split("T")[0] : "--";

//   // ✅ Fetch attendance by date
//   const fetchAttendance = (date) => {
//     setLoading(true);

//     adminDailyAttendanceApi(date)
//       .then((res) => {
//         if (res?.success && Array.isArray(res.data)) {
//           setRecords(res.data);
//         } else {
//           setRecords([]);
//         }
//       })
//       .catch(() => setRecords([]))
//       .finally(() => setLoading(false));
//   };


//   // ✅ Load when date changes
//   // useEffect(() => {
//   //   fetchAttendance(selectedDate);
//   // }, [selectedDate]);

//   useEffect(() => {
//     if (selectedDate) {
//       const formatted = selectedDate.toISOString().split("T")[0];
//       fetchAttendance(formatted);
//     }
//   }, [selectedDate]);





//   if (loading) {
//     return (
//       <div className="p-6 text-center text-gray-600">
//         Loading attendance...
//       </div>
//     );
//   }










// // total_minutes ke liye
// const getTotalMinutes = (row) => row.total_minutes || 0;

// // break_minutes ke liye
// const getBreakMinutes = (row) => row.break_minutes || 0;

// // punch_in (HH:MM:SS) ke liye
// const getPunchInSeconds = (time) => {
//   if (!time) return 0;
//   const [h = 0, m = 0, s = 0] = time.split(":").map(Number);
//   return h * 3600 + m * 60 + s;
// };












 




//   const sortedRecords = [...records].sort((a, b) => {
//     // Default alphabetical
//     if (!sortBy) {
//       return (a.name || "")
//         .toLowerCase()
//         .localeCompare((b.name || "").toLowerCase());
//     }
  
//     let result = 0;
  
//     if (sortBy === "HOURS") {
//       result = getTotalMinutes(b) - getTotalMinutes(a);
//     }
  
//     if (sortBy === "BREAK") {
//       result = getBreakMinutes(b) - getBreakMinutes(a);
//     }
  
//     if (sortBy === "LATE") {
//       result = getPunchInSeconds(a.punch_in) - getPunchInSeconds(b.punch_in);
//     }
  
//     // If equal, fallback to alphabetical
//     if (result === 0) {
//       return (a.name || "")
//         .toLowerCase()
//         .localeCompare((b.name || "").toLowerCase());
//     }
  
//     return result;
//   });
  

//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);

//   const totalPages = Math.ceil(sortedRecords.length / recordsPerPage);




//   // useEffect(() => {
//   //   setCurrentPage(1);
//   // }, [selectedDate, sortBy]);


//   return (
//     <>
//       {/* <div className="px-3 md:px-6 mt-4 ">
//         <Header />
//       </div> */}

// <div className=" px-4 py-6 md:mt-14 flex justify-center">
//         <div className="w-full max-w-7xl rounded-3xl bg-gradient-to-br from-[#2b1a63] to-[#160f3a] shadow-2xl p-6">

//           {/* HEADER */}
//           <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

//             <h2 className="font-semibold text-md whitespace-nowrap text-white">
//               {/* All Users Attendance ({selectedDate}) */}
//               All Users Attendance ({selectedDate?.toISOString().split("T")[0]})

//             </h2>

            

// {/* RIGHT: DATE FILTER + RESET */}
// <div className="flex  gap-2 justify-center  ">

// <select
//   value={sortBy}
//   onChange={(e) => setSortBy(e.target.value)}
//   className="
// shadow-lg
// rounded-lg
// w-[144px] py-2
// text-sm
// bg-[#F3F4F6]

// focus:outline-none
// focus:ring-1
// focus:ring-gray-200
// cursor-pointer
// "
// >
//   <option value="">Filter</option>
//   <option value="HOURS">Total Working Hours</option>
//   <option value="BREAK">Total Break Duration</option>
//   <option value="LATE">Punch-In Time</option>
// </select>
  
 

// <DatePicker
//   selected={selectedDate}
//   onChange={(date) => setSelectedDate(date)}
//   dateFormatCalendar=" "    // <-- hide the header
//   dateFormat="yyyy-MM-dd"
//   className="shadow-lg rounded-lg w-[144px] py-2 text-sm bg-[#F3F4F6] px-3 cursor-pointer"
//   calendarClassName="custom-calendar"
//   showMonthDropdown
//   showYearDropdown
//   scrollableYearDropdown
//   yearDropdownItemNumber={6}
// /> 



 
//   </div>
//   <button
//       // onClick={() => setSelectedDate(today)}
//       onClick={() => setSelectedDate(new Date())}
//       className=" px-3 py-2 rounded-lg text-sm bg-[#F3F4F6] hover:bg-gray-200 shadow-lg"
//     >
//       Reset
//     </button>

//   </div>

//           {/* TABLE */}

//           <div className="overflow-x-auto rounded-2xl bg-white/5 backdrop-blur">
//             <table className="min-w-[900px] w-full text-sm text-white">
//               <thead>
//                 <tr className="text-left text-gray-300 border-b border-white/10">
//               <th className="  p-3 whitespace-nowrap text-sm">Name</th>
//                 <th className="p-3 whitespace-nowrap text-sm">Punch In</th>
//                 <th className="p-3 whitespace-nowrap text-sm">Image In</th>
// <th className="p-3 whitespace-nowrap text-sm">Image Out</th>
//                 <th className="p-3 whitespace-nowrap text-sm">Punch Out</th>
//                 <th className="p-3 whitespace-nowrap text-sm">Total Hours</th>
//                 <th className="p-3 whitespace-nowrap text-sm">Break</th>
//                 <th className="p-3 whitespace-nowrap text-sm">Status</th>
//                 <th className="p-3 whitespace-nowrap text-sm">Early / Extra</th>
//               </tr>
//             </thead>



//               <tbody>
//                 {records.length > 0 ? (
//                   // records.map((row, i) => (
//                     // sortedRecords.map((row, i) => (
//                       currentRecords.map((row, i) => (
//                     <tr key={row.user_id || i} 
//                     className="border-b border-white/5 hover:bg-white/10 transition"
//                     >

//                       {/* NAME */}
                

// <td className="p-3 text-center text-sm">
//   <div
//     className="flex items-center gap-3 cursor-pointer"
//     onClick={() => navigate(`/users/${row.user_id}`)}
//   >
//     {/* PROFILE PIC */}
//     <div className="w-9 h-9 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center shadow">
//                             {row.profile_pic ? (
//                               <img
//                                 src={`${IMAGE_BASE_URL}${row.profile_pic}`}
//                                 className="w-full h-full object-cover"
//                                 alt="profile"
//                               />
//                             ) : (
//                               <span className="text-gray-400">👤</span>
//                             )}
//                           </div>
//                           <p className="font-medium hover:text-[#3BC9FC] hover:underline whitespace-nowrap">
//                             {row.name || "—"}
//                           </p>
//                         </div>
//                       </td>

//                       {/* DATE */}
                
//                       <td className="p-3 text-sm">{row.punch_in || "—"}</td>

//                       <td className="p-3 text-sm">
//                         {row.punch_in_img ? (
//                           <img
//                             src={`${IMAGE_BASE_URL}/${row.punch_in_img}`}
//                             className="w-10 h-10 rounded cursor-pointer"
//                             onClick={() =>
//                               setImagePreview(`${IMAGE_BASE_URL}/${row.punch_in_img}`)
//                             }
//                           />
//                         ) : "—"}
//                       </td>

//                       <td className="p-3 text-sm">
//                         {row.punch_out_img ? (
//                           <img
//                             src={`${IMAGE_BASE_URL}/${row.punch_out_img}`}
//                             className="w-10 h-10 rounded cursor-pointer"
//                             onClick={() =>
//                               setImagePreview(`${IMAGE_BASE_URL}/${row.punch_out_img}`)
//                             }
//                           />
//                         ) : "—"}
//                       </td>

//                       <td className="p-3 text-sm">{row.punch_out || "—"}</td>

//                       <td className="p-3 text-sm">
//                         {row.total_minutes
//                           ? `${Math.floor(row.total_minutes / 60)}h ${row.total_minutes % 60}m`
//                           : "—"}
//                       </td>

//                       {/* <td className="p-3 text-sm">{row.break_minutes ?? 0}m</td> */}
//                       <td className="p-3 text-sm">
//   {Number(row.break_minutes) === 0
//     ? "Not taken "
//     : `${row.break_minutes}m`}
// </td>


//                       <td className="p-3 text-sm">
//                         <span className={`px-3 py-1 rounded-full text-xs ${
//                           row.status ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
//                         }`}>
//                           {row.status ? "Present" : "Absent"}
//                         </span>
//                       </td>

//                       <td className="p-3 text-xs text-sm">
//                         Early: {row.early_time || "0m"} <br />
//                         Extra: {row.extra_time || "0m"}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="10" className="text-center p-6 text-gray-500">
//                       No Attendance Records Found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>



//           </div>
//           {totalPages > 1 && (
//   <div className="flex justify-center mt-6 gap-2">
//     {Array.from({ length: totalPages }, (_, i) => (
//       <button
//         key={i}
//         onClick={() => setCurrentPage(i + 1)}
//         className={`px-4 py-2 rounded-lg text-sm transition-all
//           ${
//             currentPage === i + 1
//               ? "bg-white text-black shadow-lg"
//               : "bg-white/10 text-white hover:bg-white/20"
//           }
//         `}
//       >
//         {i + 1}
//       </button>
//     ))}
//   </div>
// )}
//         </div>
//       </div>

//       {/* IMAGE MODAL */}
//       {imagePreview && (
//         <div
//           className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
//           onClick={() => setImagePreview(null)}
//         >
//           <div className="bg-white p-4 rounded-xl">
//             <img src={imagePreview} className="max-h-[80vh]" />
//           </div>
//         </div>
//       )}
//     </>
//   );
// }




